import { typeWireOf } from "@typewirets/core";
import { api } from "@/lib/api";
import type { EntitiesAPI, EntitiesByIdsResponse } from "./entities.api";

export const EntitiesAPIWire = typeWireOf({
  token: "EntitiesAPI",
  createWith(): EntitiesAPI {
    const impl: EntitiesAPI = {
      async fetchByIds(ids: string[]): Promise<EntitiesByIdsResponse> {
        if (!ids || ids.length === 0) return { entities: {} };
        return api.get<EntitiesByIdsResponse>("datahub/entities/", {
          params: { ids: ids.join(",") },
        });
      },
    };

    return impl;
  },
});
